<div class="main-header" [ngClass]="{'head-mobile': !isDesktop, 'active': openListMenu === true }">  
    <!-- front menu -->
    <div class="d-flex front justify-content-between align-items-center">
        <a routerLink="/home" class="logo d-flex align-items-center" (click)="closeMenu()">
            <img src="../../../assets/images/icon/logo-sagro.png" alt="">
            <!--<span class="pl-2">Prime Agri Resources</span>-->
        </a>   
        <div class="open-menu d-flex align-items-center">
            <div class="ic-lang pointer mr-2 d-sm-block d-none" (click)="onOpenLang()"> 
                <img src="../../../assets/images/icon/globe.svg" alt="">
            </div>
            <div class="w-enid d-none" [ngClass]="{'d-sm-block': openLang}">
                <a #langen (click)="closeMenu(); changeLanguage('en')">EN</a>
                <span class="px-1">|</span>
                <a #langid (click)="closeMenu(); changeLanguage('id')">ID</a>
            </div>
            <a routerLink="/search" class="ic-search pointer mx-4 d-sm-block d-none">
                <i class="icon ion-md-search"></i>
            </a>
            <div class="hamburger" (click)="onOpenMenu()">
                <span class="line line-1"></span>
                <span class="line my-1 line-2"></span>
                <span class="line line-3"></span>
            </div>
        </div> 
    </div>
    <!-- all menu -->
    <div class="container-fluid list-menu">
        <div class="row">
            <div class="col-md-10 initial mx-auto">
                <!-- list menu top -->
                <ul class="nav li-2 my-3 justify-content-between menu-individual align-items-center">
                    <li class="search">
                        <div class="form-search position-relative">
                            <input type="text" placeholder="Search" 
                                    class="form-control" 
                                    [formControl]="search" 
                                    (keydown)="onSearch($event)">
                            <span class="ic-search pointer" (click)="onSearch($event)">
                                <i class="icon ion-md-search"></i>
                            </span>
                        </div>
                    </li>
                    <ng-container *ngFor="let item of dataHeader; let key = index">
                        <li class="d-lg-block d-none" (click)="closeMenu()" *ngIf="key > 6">
                            <a routerLink="/{{item.link}}">{{ item.title }}</a>
                        </li>
                    </ng-container>
                    <li class="lang"> 
                        <img class="ic-lang pr-2" src="../../../assets/images/icon/globe.svg" alt="">
                        <a #langen2 (click)="closeMenu(); changeLanguage('en')">EN</a>
                        <span class="px-1">|</span>
                        <a #langid2 (click)="closeMenu(); changeLanguage('id')">ID</a>
                    </li>
                </ul>
                <!-- menu list -->
                <perfect-scrollbar class="scroll-header">
                    <div class="menu-children">
                        <ng-container *ngFor="let item of dataHeader; let key = index">
                            <!-- with children -->
                            <ng-container *ngIf="item.children.length != 0">
                                <div class="w-menu" *ngIf="key > 0 && key <= 6">
                                    <div class="w-title" (click)="onOpenDropdown($event)">{{ item.title }}</div>
                                    <div class="child" (click)="closeMenu()">
                                        <ul class="no-list li-2">
                                            <ng-container *ngFor="let subMenu of item.children">
                                                <li><a routerLink="/{{item.link}}/{{subMenu.link}}">{{ subMenu.title }}</a></li>
                                            </ng-container>
                                        </ul>
                                    </div>
                                </div>
                            </ng-container>
                            <!-- no children -->
                            <ng-container *ngIf="item.children.length == 0">
                                <div class="w-menu" *ngIf="key > 0 && key <= 6">
                                    <a routerLink="/{{item.link}}" 
                                        (click)="closeMenu()" 
                                        class="w-title">
                                        {{item.title}}
                                    </a>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>
                     <!-- mobile list bottom -->
                    <ul class="nav li-2 d-lg-none d-flex d-mobile justify-content-center text-center menu-individual align-items-center">
                        <ng-container *ngFor="let item of dataHeader; let key = index">
                            <li (click)="closeMenu()" class="pr-1" *ngIf="key > 6">
                                <a routerLink="/{{item.link}}">{{ item.title }}</a>
                            </li>
                        </ng-container>
                    </ul>
                </perfect-scrollbar>
            </div>
        </div>
    </div>
</div>

<!-- scroll down header -->
<div class="header-logo" *ngIf="isDesktop"> 
    <a routerLink="/home" class="logo d-flex align-items-center" (click)="closeMenu()">
        <img src="../../../assets/images/icon/logo-sagro.png" alt="">
    </a>   
</div>